import formatValue from './formatValue';

const formatNumber = function(value, unit, decimalPlaces = 2) {
    if (unit === 's') {
        return formatValue(Number(value), unit, decimalPlaces);
    }

    if (unit === 'm3') {
        value = Intl.NumberFormat(WiseMetering.currentLocale.name, { maximumFractionDigits: decimalPlaces }).format(value);
        return `${value} ${unit}`;
    }

    if (unit === '€') {
        value = Intl.NumberFormat(WiseMetering.currentLocale.name, { style: 'currency', currency: 'EUR' }).format(value);

        return `${value}`;
    }

    if (unit === '£') {
        value = Intl.NumberFormat(WiseMetering.currentLocale.name, { style: 'currency', currency: 'GBP' }).format(value);

        return `${value}`;
    }

    value = Number(value);
    let power = '';
    if (unit === 'N/A') {
        unit = '';
    }

    if (Math.abs(value) >= 1000000) {
        value = value / 1000000;
        power = 'M';
    } else if (Math.abs(value) >= 1000) {
        value = value / 1000;
        power = 'k';
    }

    value = Intl.NumberFormat(WiseMetering.currentLocale.name, { maximumFractionDigits: decimalPlaces }).format(value);
    return `${value} ${power}${unit}`;
};

export default formatNumber;
